import React from 'react'
import { Helmet } from 'react-helmet'

import './BreakHTMLFooter.scss'
const BreakHTMLFooter = props => {
  const { content } = props

  return (
    <>
      <Helmet
        bodyAttributes={{
          'break-html-footer': `${content ? `visible` : ``}`,
        }}
      />
      <div className={`break-html-footer`}>
        {content && (
          <div
            className={`break-html-content`}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </>
  )
}
export default BreakHTMLFooter
